import axios from "axios";
import { clearGate } from "./gate";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const GATE_LOST_EVENT = "aegis:gate-lost";

// The gate session travels as an httpOnly cookie, so every call must send credentials.
export const http = axios.create({ baseURL: API, withCredentials: true });

http.interceptors.response.use(
  (r) => r,
  (error) => {
    const detail = error?.response?.data?.detail;
    const gateFailure = typeof detail === "string" && detail.startsWith("terminal_gate");
    if (error?.response?.status === 401 && gateFailure) {
      clearGate();
      window.dispatchEvent(new CustomEvent(GATE_LOST_EVENT, { detail }));
    }
    return Promise.reject(error);
  }
);

export function downloadBlob(filename, blob) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function downloadJSON(filename, data) {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export async function copyText(text) {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (e) {
    console.warn("Clipboard API unavailable, falling back to execCommand", e);
  }
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch (e) {
    console.warn("Copy to clipboard failed", e);
    return false;
  }
}
